export default /* glsl */`
precision highp float;

uniform float viewportWidth;
uniform float viewportHeight;
uniform vec3 color0;
uniform vec3 color1;
uniform vec3 color2;
uniform float ratio0;
uniform float ratio1;
uniform float ratio2;
uniform float rotate;
uniform float opacity;

uniform vec3 fogColor;
uniform float fogNear;
uniform float fogFar;


highp vec3 smoothstepvec3(vec3 color0, vec3 color1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(color0, color1, ratio);
}

highp float smoothstepFloat(float val0, float val1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(val0, val1, ratio);
}

mat3 rotationMat(float rotate) {
    float aRad = radians(rotate);
    float cosA = cos(aRad);
    float sinA = sin(aRad);
    return mat3(
        cosA, -sinA, 0.0,
        sinA, cosA, 0.0,
        0.0, 0.0, 1.0
    );
}

void main() {

    float size = viewportWidth * cos(rotate) + viewportHeight * sin(rotate);
    size = min(viewportWidth, viewportHeight);
    vec3 sizesVec = vec3(size, size, 1.0);
    vec3 relFragCoord = (gl_FragCoord.xyw - 0.5 * vec3(viewportWidth, viewportHeight, 0.0)) / sizesVec;

    vec3 transformedFragCoord = relFragCoord;
    transformedFragCoord = rotationMat(rotate) * transformedFragCoord;
    transformedFragCoord += vec3(0.5);

    float gradientRatio = transformedFragCoord.y;

    float ratio1 = ratio1;
    float ratio = ratio0;
    vec3 color1 = color1;
    highp vec3 color = color0;
    bool needStep = false;

    if (ratio1 > 0.0 && gradientRatio > ratio) {
        if (gradientRatio > ratio1) {
            ratio = ratio1;
            color = color1;
        } else {
            needStep = true;
        }
    }

    if (needStep) {
        color = smoothstepvec3(color, color1, ratio, ratio1, gradientRatio);
    }

    float alpha = opacity;

    #ifdef ALPHATEST

        if ( alpha < ALPHATEST ) discard;

    #endif

    gl_FragColor = vec4(color, alpha);


    #ifdef USE_FOG
          #ifdef USE_LOGDEPTHBUF_EXT
              float depth = gl_FragDepthEXT / gl_FragCoord.w;
          #else
              float depth = gl_FragCoord.z / gl_FragCoord.w;
          #endif
          float fogFactor = smoothstep( fogNear, fogFar, depth );
          gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      #endif
    if (gl_FragColor.a < 0.0001) discard;
}
`;
